import React, { Component } from 'react';
import Select from 'react-select'
import InputText, { InputSelect, InputSelectMagasin, TextArea } from '../../../../commonModules/interface/form-input-inline.jsx';
import FormLayout from '../containers/FormLayout.jsx';

import { isEmpty } from 'lodash';
import Photos from '../../../../commonModules/interface/input-files.jsx';
import { Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid } from '@material-ui/core';
import { Fragment } from 'react';
import DatePicker from '../../../../commonModules/MUI/DatePicker.jsx';
import CardFormLayout from '../containers/CardFormLayout.jsx';

class FormArrivage extends Component {

    createShopList = () => {
        const {SHOPS, purchase} = this.props
        let list = [{value:"", label:"Chosissez un Magasin"}]
        if( !isEmpty(SHOPS) ){// select shop options in Form
            Object.values(SHOPS).forEach( shop => { 
                list.push ({
                    value:shop.id, 
                    label:shop.name, 
                    disabled: (purchase.shop === shop.id || !!shop.shop_disabled) 
                })
            })
        }
        return list
    }

    render() {
        console.log("[PROPS PURCHASE]", this.props)
        return (
            <CardFormLayout
                title={this.props.update ? "Modifier l'arrivage" : ( this.props.demand ? "Nouvelle Demande Achat" : "Nouvel Arrivage" )}
                disabled={this.props.STATE.demands.fetching || this.props.STATE.arrivages.fetching}
                handleSubmit={ this.props.handleSubmit }
                cancelSubmit={this.props.handleClose}
            >
                
                <Box p={2}>
                    <InputSelectMagasin 
                        label="Magasin"
                        options={this.createShopList()}
                        value={this.props.purchase.shopDisplay}
                        onChange={ option => this.props.handleSelect(option, "shop")}
                        // isOptionDisabled={ option => option.disabled === true}
                        error={this.props.errors.shop}
                    />
                    <FormLayout 
                        {...this.props} 
                        title={"Produits"}
                        createAddForm={this.props.createAddForm}
                        onClick={this.props.handleAddProd}
                        onClickForCSVUpload={this.props.handleAddProdByCSV}
                        colSpan={2}
                        rea
                    />          
                    <Box p={2}>
                        {!this.props.demand &&
                            <Grid spacing={1} container>
                                <Grid item xs={12}  md={6} lg={3}>
                                    {/* <label htmlFor="transfer_files_BL" className="control-label">Bon de Livraison</label> */}
                                    <Photos
                                        saved={this.props.arrivage ? this.props.arrivage.transfer_files_BL : null}
                                        buttonTitle="BL"
                                        id="transfer_files_BL_req"
                                        photoList={(list) => this.props.setFiles(list, "transfer_files_BL_req")} 
                                        photos={this.props.purchase.transfer_files_BL_req === null ? [] : this.props.purchase.transfer_files_BL_req } 
                                        file 
                                    />
                                </Grid>
                                <Grid item xs={12}  md={6} lg={3}>
                                    {/* <label htmlFor="transfer_files_BESC" className="control-label">BESC</label> */}
                                    <Photos
                                        saved={this.props.arrivage ? this.props.arrivage.transfer_files_BESC : null}
                                        buttonTitle="BESC"
                                        id="transfer_files_BESC_req"
                                        photoList={(list) => this.props.setFiles(list, "transfer_files_BESC_req")} 
                                        photos={this.props.purchase.transfer_files_BESC_req === null ? [] : this.props.purchase.transfer_files_BESC_req } 
                                        file 
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={3}>
                                    {/* <label htmlFor="transfer_files_fact" className="control-label">Facture</label> */}
                                    <Photos
                                        saved={this.props.arrivage ? this.props.arrivage.transfer_files_fact : null}
                                        buttonTitle="Facture"
                                        id="transfer_files_fact_req"
                                        photoList={(list) => this.props.setFiles(list, "transfer_files_fact_req")} 
                                        photos={this.props.purchase.transfer_files_fact_req === null ? [] : this.props.purchase.transfer_files_fact_req } 
                                        file 
                                    />
                                </Grid>
                                <Grid item xs={12} md={6} lg={3}>
                                    {/* <label htmlFor="transfer_files" className="control-label">Autres</label> */}
                                    <Photos
                                        saved={this.props.arrivage ? this.props.arrivage.transfer_files : null}
                                        buttonTitle="Autres"
                                        id="transfer_files_req"
                                        photoList={(list) => this.props.setFiles(list, "transfer_files_req")} 
                                        photos={this.props.purchase.transfer_files_req === null ? [] : this.props.purchase.transfer_files_req } 
                                        file 
                                    />
                                </Grid>
                            </Grid>
                        }
                    </Box>              
                    {!this.props.demand ?
                    <>
                        <DatePicker 
                            label="Date d'arrivée estimée"
                            // minDate={new Date()}
                            value={this.props.purchase.estimate_arrival_date}
                            onChange={this.props.handleChangeDate}
                        /> 
                        <InputText 
                            name="purchase_BL_number" 
                            value={this.props.purchase.purchase_BL_number} 
                            error={this.props.errors.purchase_BL_number} 
                            change={this.props.handleChange} 
                            title="Numero de BL" 
                            required
                        />
                        </>
                    :
                        <DatePicker
                            label="Date d'arrivée souhaitée"
                            minDate={new Date()}
                            value={this.props.purchase.estimate_arrival_date}
                            onChange={this.props.handleChangeDate}
                        /> 
                    }
                    <TextArea 
                        name="comments" 
                        value={this.props.purchase.comments} 
                        error={this.props.errors.comments} 
                        change={this.props.handleChange} 
                        title="Commentaire" 
                        required
                        rows={3}
                        placeholder="Informations complémentaire" 
                    />
                    <InputText 
                        name="user_name" 
                        value={this.props.purchase.user_name} 
                        error={this.props.errors.user_name} 
                        change={this.props.handleChange} 
                        title="Nom auteur" 
                        required
                        placeholder="NOM Prénom" 
                    />
                    {/* <Box p={2}>
                        <Button 
                            color="secondary"
                            variant="contained"
                            className="confirm"
                            disabled={this.props.STATE.demands.fetching || this.props.STATE.arrivages.fetching}
                            onClick={ this.props.handleSubmit }
                        >
                            Valider
                        </Button>
                        <Button 
                            color="secondary"
                            onClick={this.props.handleClose}
                        >
                            Annuler
                        </Button>
                    </Box> */}
                </Box>
            </CardFormLayout>
        );
    }
}

export default FormArrivage;
